module.exports = __webpack_public_path__ + "fonts/AkagiPro-Black.91adf9b7.ttf";